import auth from "../middlewares/auth";
export const notice = [
    {
        path: '/notice',
        component: () => import(/* webpackChunkName: "notice" */ '../views/notice/Index'),
        name: 'notice',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/notice/add',
        component: () => import(/* webpackChunkName: "notice" */ '../views/notice/Form'),
        name: 'notice_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/notice/edit/:id',
        component: () => import(/* webpackChunkName: "notice" */ '../views/notice/Form'),
        name: 'notice_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
